import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';
import get from 'lodash/get';

const useSppTelemetrySend = (props) => {
  const { subject, sectionId, isSandbox = false, assessment } = props;
  const {
    importId: cbUserId,
    initId: amUserId,
    schoolSet,
    sections = [],
    isStudent,
  } = window.current_user || {};

  const commonData = useMemo(() => {
    const data = {
      app: 'fym/spp',
      subject_name: subject.name,
      subject_id: subject.id,
      student_initiated: isStudent,
    };

    const getTeacherData = () => ({
      ...data,
      user: {
        am_user_id: amUserId,
        cb_person_id: cbUserId,
      },
    });

    const getStudentData = (currentSchool, currentClass) => ({
      ...data,
      school_id: get(currentSchool, 'groupImportId', '0'),
      class_id: get(currentClass, 'importId', '0'),
      teacher_id: get(currentClass, 'teacherId', '0'),
      cb_teacher_id: get(currentClass, 'teacherCbPersonId', '0'),
      user: {
        cb_person_id: cbUserId,
      },
      is_exam_only_class: !currentClass,
    });

    if (subject) {
      const currentClass = !!sectionId
        ? sections.find((section) => section.id === sectionId.toString())
        : sections.find(
            (section) => section.masterSubjectId === subject.id.toString(),
          );

      const currentSchool =
        currentClass &&
        schoolSet.find((school) => school.initId === currentClass.parentId);

      return isStudent
        ? getStudentData(currentSchool, currentClass)
        : getTeacherData();
    }
  }, [subject, sectionId]);

  const commonDataWithSpp = useMemo(() => {
    if (isStudent) {
      return (
        commonData &&
        assessment && {
          ...commonData,
          spp_id: assessment.id,
          spp_learnosity_reference: assessment.learnosityItemReference,
          spp_title: assessment.title,
          assigned: isSandbox ? 0 : 1,
        }
      );
    }
    return commonData;
  }, [commonData, isSandbox, assessment]);

  const sppTelemetrySend = useMemo(() => {
    if (commonDataWithSpp) {
      return ({ event_type, ...data }) =>
        sendToTelemetry({
          event_type,
          ...TLTRY_DEFAULTS[0],
          ...commonDataWithSpp,
          ...data,
        });
    }
  }, [commonDataWithSpp]);

  return sppTelemetrySend;
};

useSppTelemetrySend.propTypes = {
  subject: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  sectionId: PropTypes.string,
  isSandbox: PropTypes.bool,
  assessment: PropTypes.shape({
    learnosityItemReference: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};

export default useSppTelemetrySend;
